
<p-card>
    <div class="flex">
        <div *ngIf="snps" class="result-detail">
            <h2>Sample ID: {{snps[0].sampleId}}</h2>
            <h2>Order Date: {{snps[0].orderDate | date:'shortDate'}}</h2>
            <h2>Wellplate: {{snps[0].wellplateName}}</h2>
            <h2>Sample: {{snps[0].sampleName}}</h2>
            <h2>Strain: {{snps[0].strainName}}</h2>
        </div>
        <div class="card snp-list">
            <div class="card-container">
                <div class="flex">
                    <div class="flex-initial mr-2 snp-item">Probe</div>
                    <div class="flex-initial mr-2 snp-item">Result</div>
                    <div class="flex-initial mr-2 snp-item">Reference</div>
                </div>
                <div *ngIf="snps != undefined">
                    <div *ngFor="let snp of snps" class="flex" [ngClass]="getSnpClass(snp.result, snp.referenceProbe?.value)">
                        <div class="flex-initial flex mr-2 snp-item">{{snp.probeName}}</div>
                        <div class="flex-initial flex mr-2 snp-item">{{snp.result}}</div>
                        <div class="flex-initial flex mr-2 snp-item">{{snp.referenceProbe?.value}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <h5>Reference</h5>
            <p-dropdown [options]="references" [(ngModel)]="selectedReference" optionLabel="name" [filter]="true" 
            filterBy="name" [showClear]="true" placeholder="Select a Reference" (onChange)="referenceChange()">
                <ng-template pTemplate="selectedItem">
                    <div class="country-item country-item-value" *ngIf="selectedReference">
                        <div>{{selectedReference.name}}</div>
                    </div>
                </ng-template>
                <ng-template let-references pTemplate="item">
                    <div class="country-item">
                        <div>{{references.name}}</div>
                    </div>
                </ng-template>
            </p-dropdown>
            <!--<h5>Add Reference</h5>
            <p-fileUpload #fubauto mode="basic" name="references[]" url="./" accept="image/*" (onUpload)="onUpload($event)" [auto]="true" chooseLabel="Browse"></p-fileUpload>-->
        </div>
    </div>
</p-card>